// Etapas do pipeline de licitações — ESPELHO de
// dre-sistema/lambda/comercial-engine/handlers/licitacoesEtapas.js (02/10/2026).
//
// A verdade mora no servidor; este arquivo repete códigos, rótulos, cores e
// motivos para a tela desenhar colunas e perguntar motivo sem uma ida ao
// servidor. tests/licitacoes/pipeline-etapas.test.js (node, no CI) lê ESTE
// arquivo como texto e cobra que cada `codigo:` e cada rótulo existam lá —
// mudou lá, muda aqui, ou o CI barra.
//
// Quem decide se um movimento pode é o servidor (`lic_mover_etapa`), e a tela
// mostra a frase dele. Aqui só o que a tela precisa saber ANTES de perguntar:
// quais destinos são fim de linha e quais pedem motivo.

export interface Etapa {
  codigo: string;
  rotulo: string;
  curto: string;
  cor: string;
  fundo: string;
}

/** Fora do quadro (lista de Oportunidades). */
export const TRIAGEM = ['novo', 'em_analise', 'descartado'];

/** As colunas do quadro, na ordem do processo público. */
export const ETAPAS: Etapa[] = [
  { codigo: 'avaliando',            rotulo: 'Avaliando',              curto: 'Avaliando',   cor: '#5A6378', fundo: '#F4F5F8' },
  { codigo: 'preparacao',           rotulo: 'Preparação',             curto: 'Preparação',  cor: '#4A6285', fundo: '#EEF1F6' },
  { codigo: 'proposta',             rotulo: 'Proposta',               curto: 'Proposta',    cor: '#7A6440', fundo: '#F4EFE8' },
  { codigo: 'sessao',               rotulo: 'Sessão',                 curto: 'Sessão',      cor: '#3B5485', fundo: '#E8EBF4' },
  { codigo: 'habilitacao_recursos', rotulo: 'Habilitação e recursos', curto: 'Habilitação', cor: '#6B5320', fundo: '#F0EAD9' },
  { codigo: 'homologacao',          rotulo: 'Homologação',            curto: 'Homolog.',    cor: '#2C5C42', fundo: '#E6F0EA' },
];

/** Fim de linha. */
export const TERMINAIS: Etapa[] = [
  { codigo: 'ganho',            rotulo: 'Contrato assinado', curto: 'Assinado',    cor: '#0a7f4a', fundo: '#E6F0EA' },
  { codigo: 'perdido',          rotulo: 'Perdido',           curto: 'Perdido',     cor: '#8B3A3A', fundo: '#F7E8E8' },
  { codigo: 'nao_participamos', rotulo: 'Não participamos',  curto: 'Não partic.', cor: '#5A6378', fundo: '#F1F2F5' },
];

export const ABERTAS = ETAPAS.map(e => e.codigo);
export const FINAIS = TERMINAIS.map(e => e.codigo);
export const TODAS = [...ABERTAS, ...FINAIS];

/** Status legado (antes de 02/10/2026) que vale como Proposta. */
const ALIAS: Record<string, string> = { em_proposta: 'proposta' };
export const normalizar = (s?: string | null) => ALIAS[String(s || '')] || String(s || '');
export const ehAberta = (s?: string | null) => ABERTAS.includes(normalizar(s));
export const ehTerminal = (s?: string | null) => FINAIS.includes(normalizar(s));
export const ehTriagem = (s?: string | null) => TRIAGEM.includes(normalizar(s));
export const etapaDe = (s?: string | null): Etapa | null => {
  const c = normalizar(s);
  return ETAPAS.find(e => e.codigo === c) || TERMINAIS.find(e => e.codigo === c) || null;
};
export const rotuloDe = (s?: string | null) =>
  etapaDe(s)?.rotulo || ({ novo: 'Novo', em_analise: 'Em análise', descartado: 'Descartado' } as Record<string, string>)[normalizar(s)] || normalizar(s);

/** Destinos que pedem motivo antes de mover (o servidor recusa sem ele). */
export const pedeMotivo = (para: string) => para === 'perdido' || para === 'nao_participamos';

export const MOTIVOS_PERDA = [
  'Preço — perdemos no valor',
  'Desclassificação técnica',
  'Inabilitação (documento)',
  'Não enviamos a proposta a tempo',
  'Licitação revogada ou anulada',
  'Fracassada ou deserta',
  'Suspensa sem data',
  'Outro motivo',
];

export const MOTIVOS_NAO_PARTICIPAR = [
  'Fora do nosso escopo',
  'Não cabe na equipe no prazo',
  'Prazo de proposta curto demais',
  'Exigência que não atendemos (atestado, índice, registro)',
  'Valor baixo para o esforço',
  'Risco contratual ou de pagamento',
  'Outro motivo',
];
